import React from 'react';
import { useMediaQuery, useTheme } from '@mui/material';
import { Popover } from '~/UIKit';
import ModalComponent from '../Modal/Modal.component';
import { makeStyles } from '~/UIKit/Style';
import { TopToolbar } from '~/UIKit/TopToolbar';

export interface IPopoverToModalProps {
  open: boolean;
  anchorEl: Element | null | undefined;
  onClose: () => void;
  children: React.ReactElement;
  onActionTaken: () => void;
  width?: number | string;
  actionDisabled?: boolean;
}

export interface ITopToolbarProps {
  title: string;
  actionName?: string;
  hideToolbar?: boolean;
  backRoute?: string;
  hideBackButton?: boolean;
  cancelInsteadOfBack?: boolean;
}

const useStyles = makeStyles((theme) => ({
  popover: {
    marginLeft: theme.spacing(4),
  },
}));

export const PopoverToModal = ({
  open,
  anchorEl,
  onClose,
  children,
  onActionTaken,
  width = 400,
  actionName,
  title,
  actionDisabled,
  backRoute,
  hideBackButton,
  cancelInsteadOfBack,
  hideToolbar,
}: IPopoverToModalProps & ITopToolbarProps) => {
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down('md'));
  const { classes } = useStyles();

  const saveAndClose = () => {
    onActionTaken();
    onClose();
  };

  if (!mobile) {
    return (
      <Popover
        open={open}
        onClose={saveAndClose}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        anchorReference="anchorEl"
        className={classes.popover}
        arrowLeft
        width={width}
      >
        {children}
      </Popover>
    );
  }

  return (
    <ModalComponent onClose={onClose} open={open} isFullHeight>
      {!hideToolbar && (
        <TopToolbar
          title={title || ''}
          action={actionName}
          onActionTaken={onActionTaken}
          actionDisabled={actionDisabled}
          backRoute={backRoute}
          hideBackButton={hideBackButton}
          onBack={onClose}
          cancelInsteadOfBack={cancelInsteadOfBack}
        />
      )}
      {children}
    </ModalComponent>
  );
};
